/**
 * base: 390px
 * lg: 768px
 * xl: 1024px
 * xxl: 1280px
 */
import { css } from '@/styled-system/css';

const infoRow = css.raw({
  display: 'flex',
  flexDirection: { base: 'column', lg: 'row', xl: 'column' },
  alignItems: { base: 'flex-start', lg: 'center', xl: 'flex-start' },
  justifyContent: 'space-between',
  gap: '{spacing.400}',
  padding: '{spacing.zero} {spacing.400}',
  width: '100%',
});

const infoCol = css.raw({
  display: 'flex',
  flexDirection: { base: 'row' },
  flex: 1,
  alignItems: { base: 'center' },
  gap: '{spacing.200}',
});

const columnEmailBox = css.raw({
  display: 'flex',
  flexDirection: 'row',
  columnGap: '{spacing.200}',
});

const columnContentMaxWidth = css.raw({
  // maxWidth: { base: '100%', lg: '124px' },
  maxWidth: { base: '100%' },
});

const iconRowItem = css.raw({
  color: '{colors.gray.400}',
});

const sectionTitleRow = css.raw({
  marginBottom: '{spacing.400}',
});

export { columnContentMaxWidth, columnEmailBox, infoRow, infoCol, iconRowItem, sectionTitleRow };
